export default __webpack_public_path__ + "static/media/hair2.e86d637a.png";